import React, { useEffect, useState } from "react";
import Logo from "../assets/images/Logo.png";
import sidenav1 from "../assets/images/sidenav-1.png";
import sidenav2 from "../assets/images/sidenav-2.png";
import sidenav3 from "../assets/images/sidenav-3.png";
import sidenav4 from "../assets/images/sidenav-4.png";
import sidenav5 from "../assets/images/sidenav-5.png";
import sidenav6 from "../assets/images/sidenav-6.png";
import sidenav7 from "../assets/images/sidenav-7.png";
import sidenav8 from "../assets/images/sidenav-8.png";
import sidenav9 from "../assets/images/sidenav-9.png";
import sidenav10 from "../assets/images/sidenav-10.png";
import logout from "../assets/images/logout.png";
import admin from "../assets/images/admin.png";
import { Link, useLocation } from "react-router-dom";
import Logout from "./Logout";
import { useSelector } from "react-redux";
import { getEmail } from "../utils/getToken";
import { useDispatch } from "react-redux";
import { viewProfile } from "../features/slices/authReducer";
import { denyAccess } from "../utils/denyAccess";

const SideBar = ({ openSideBar, open }) => {

  const [logoutModal, setLogout] = useState(false);
  const { pathname, search } = useLocation();
  const dispatch = useDispatch();
console.log({open});

  const { profileData } = useSelector((state) => {
    return state?.auth;
  });

  const type = search.split("=")[1];
  console.log({ type });
  const url = pathname.split("/")[1];
  const data = getEmail("adminLogin");

  return (
    <div>
      <div className="SidenavBar">
        <div className="SidenavHead">
          <Link to="/dashboard">
            <img src={Logo} />
          </Link>
          <div className="Toggle" onClick={openSideBar}>
            {
              open?
              <i className="fa-solid fa-chevron-right" />
              :
              <i className="fa-solid fa-chevron-left" />
            }
          </div>
        </div>
        <div className="SidenavBody">
          <ul>
              <li className={`${url == "dashboard" ? "active" : ""}`}>
                <Link to={"/dashboard"}>
                  <span className="Icon">
                    <img src={sidenav1} />
                  </span>
                  <span className="Text">Dashboard</span>
                </Link>
              </li>
            {/* {denyAccess("Dashboard") && (
            )} */}
            {denyAccess("Student") && (
              <li
                className={`${
                  url === "student" ||
                  url === "studentDetails" ||
                  type == "student"
                    ? "active"
                    : ""
                }`}
              >
                <Link to={"/student"}>
                  <span className="Icon">
                    <img src={sidenav2} />
                  </span>
                  <span className="Text">Student Management</span>
                </Link>
              </li>
            )}
            {denyAccess("Feed") && (
              <li className={`${url == "feed" ? "active" : ""}`}>
                <Link to={"/feed"}>
                  <span className="Icon">
                    <img src={sidenav3} />
                  </span>
                  <span className="Text">Feed Management</span>
                </Link>
              </li>
            )}
            {denyAccess("Category") && (
              <li
                className={`${
                  url == "category" || url === "topicDetails" ? "active" : ""
                }`}
              >
                <Link to={"/category"}>
                  <span className="Icon">
                    <img src={sidenav4} />
                  </span>
                  <span className="Text">Category Management</span>
                </Link>
              </li>
            )}
            {denyAccess("Courses") && (
              <li
                className={`${
                  type == "student" ? "" : url == "courses" ? "active" : ""
                }`}
              >
                <Link to={"/courses"}>
                  <span className="Icon">
                    <img src={sidenav5} />
                  </span>
                  <span className="Text">Courses Management</span>
                </Link>
              </li>
            )}
            {denyAccess("Podcasts") && (
              <li
                className={`${
                  type == "student" ? "" : url == "podcast" ? "active" : ""
                }`}
              >
                <Link to={"/podcast"}>
                  <span className="Icon">
                    <img src={sidenav6} />
                  </span>
                  <span className="Text">Podcast Management</span>
                </Link>
              </li>
            )}
            {denyAccess("Challenges&Bounty") && (
              <li
                className={`${
                  type == "student" ? "" : url == "challenges" ? "active" : ""
                }`}
              >
                <Link to={"/challenges"}>
                  <span className="Icon">
                    <img src={sidenav7} />
                  </span>
                  <span className="Text">
                    Challenges &amp; Bounty Management
                  </span>
                </Link>
              </li>
            )}
            {denyAccess("Livestream") && (
              <li
                className={`${
                  type == "student" ? "" : url == "livestream" ? "active" : ""
                }`}
              >
                <Link to={"/livestream"}>
                  <span className="Icon">
                    <img src={sidenav8} />
                  </span>
                  <span className="Text">Livestream Management</span>
                </Link>
              </li>
            )}
            {/* <li className={`${url == "payment" ? "active" : ""}`}>
              <Link to={"/payment"}>
                <span className="Icon">
                  <img src={sidenav9} />
                </span>
                <span className="Text">Payment Management</span>
              </Link>
            </li> */}
            {denyAccess("Notification") && (
              <li className={`${url == "notification" ? "active" : ""}`}>
                <Link to={"/notification"}>
                  <span className="Icon">
                    <img src={sidenav10} />
                  </span>
                  <span className="Text">Notification Management</span>
                </Link>
              </li>
            )}
            {denyAccess("Sub-Admin") && (
              <li className={`${url == "subadmin" ? "active" : ""}`}>
                <Link to={"/subadmin"}>
                  <span className="Icon">
                    <img src={sidenav10} />
                  </span>
                  <span className="Text">Sub-Admin Management</span>
                </Link>
              </li>
            )}
            {denyAccess("Static-Content") && (
              <li className={`${url == "staticContent" ? "active" : ""}`}>
                <Link to={"/staticContent"}>
                  <span className="Icon">
                    <img src={sidenav10} />
                  </span>
                  <span className="Text">Static Content Management</span>
                </Link>
              </li>
            )}
            {/* <li className={`${url == "termsCondition" ? "active" : ""}`}>
              <Link to={"/termsCondition"}>
                <span className="Icon">
                  <img src={sidenav10} />
                </span>
                <span className="Text">Terms & Condition</span>
              </Link>
            </li>
            <li className={`${url == "privacyPolicy" ? "active" : ""}`}>
              <Link to={"/privacyPolicy"}>
                <span className="Icon">
                  <img src={sidenav10} />
                </span>
                <span className="Text">Privacy Policy</span>
              </Link>
            </li> */}
          </ul>
        </div>
        <div className="SidenavFooter">
          <figure>
            <img src={profileData?.activeUser?.profilePic || admin} />
          </figure>
          <figcaption>
            <h6> {profileData?.activeUser?.name}</h6>
            <p
              style={{
                textAlign: "left",
              }}
            >
              {profileData?.activeUser?.email}
            </p>
          </figcaption>
          <a onClick={() => setLogout(true)}>
            <img src={logout} />
          </a>
        </div>
      </div>
      {logoutModal && <Logout setLogout={setLogout} />}
    </div>
  );
};

export default SideBar;
